var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[(_vm.viewComponent == 'listing')?_c('Electionlisting'):_vm._e(),(_vm.viewComponent == 'election-form')?_c('Electionformstep'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }